import React, { createContext, useState, useEffect } from 'react';

export const CurpContext = createContext();

export const CurpProvider = ({ children }) => {
    const [curp, setCurp] = useState(() => {
        // Obtener el CURP del localStorage al inicializar el estado
        return localStorage.getItem('curp') || '';
    });

    useEffect(() => {
        // Guardar el CURP en el localStorage cada vez que cambie
        localStorage.setItem('curp', curp);
    }, [curp]);

    return (
        <CurpContext.Provider value={{ curp, setCurp }}>
            {children}
        </CurpContext.Provider>
    );
};
